'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var Box = require('../../../../../../common/components/layout/Box/Box.js');
var index = require('../../../../../../common/providers/ClaimBuilder/index.js');
var OTPNav = require('./OTPNav.js');
var OTPProvider = require('./OTPProvider.js');
var useTitanAnalytics = require('../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OTP = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    resetCodeRequestsForPhone
  } = OTPProvider.useOTP();

  // Reset phone number count when the OTP flow is first loaded
  React.useEffect(() => {
    resetCodeRequestsForPhone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.track({
      event: 'promotion_viewed',
      properties: {
        promotion_id: 'otp'
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4,
    style: {
      padding: '0 0 2rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(OTPNav["default"], null), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Outlet, null));
};
const OTPGuarded = () => {
  const {
    state: {
      claimEligibilityInfo
    },
    handleInvalidData
  } = index.useClaimBuilder();
  if (!claimEligibilityInfo) {
    handleInvalidData();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(OTPProvider.OTPProvider, null, /*#__PURE__*/React__default["default"].createElement(OTP, null));
};

exports["default"] = OTPGuarded;
